import React, { useState } from 'react';
import PublicLayout from '../components/PublicLayout';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

export default function ContactPage() {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for contacting ODAZAPP. We will get back to you soon.');
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <PublicLayout>
            <section className="py-24 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-premium-gold/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
                        {/* Contact Info */}
                        <div className="space-y-12">
                            <h1 className="text-5xl md:text-7xl font-black text-white tracking-tighter">
                                Contact <br />
                                <span className="premium-gradient-text">Us</span>
                            </h1>
                            <p className="text-gray-400 text-xl font-light leading-relaxed max-w-md">
                                Have a question or feedback? We'd love to hear from you. Experience the extraordinary together.
                            </p>

                            <div className="space-y-8">
                                <div className="flex items-center gap-6 group">
                                    <div className="w-14 h-14 bg-premium-gold/10 rounded-2xl flex items-center justify-center group-hover:bg-premium-gold group-hover:text-premium-teal transition-all duration-500">
                                        <Mail className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <div className="text-sm font-black text-premium-gold uppercase tracking-widest mb-1">Email</div>
                                        <div className="text-white text-lg font-bold">support@odaz.app</div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-6 group">
                                    <div className="w-14 h-14 bg-premium-gold/10 rounded-2xl flex items-center justify-center group-hover:bg-premium-gold group-hover:text-premium-teal transition-all duration-500">
                                        <Phone className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <div className="text-sm font-black text-premium-gold uppercase tracking-widest mb-1">Phone</div>
                                        <div className="text-white text-lg font-bold">+255 650 000 000</div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-6 group">
                                    <div className="w-14 h-14 bg-premium-gold/10 rounded-2xl flex items-center justify-center group-hover:bg-premium-gold group-hover:text-premium-teal transition-all duration-500">
                                        <MapPin className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <div className="text-sm font-black text-premium-gold uppercase tracking-widest mb-1">Location</div>
                                        <div className="text-white text-lg font-bold">Dodoma Tanzania</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="relative">
                            <div className="absolute inset-0 bg-premium-gold/10 rounded-[3rem] blur-3xl"></div>
                            <div className="relative bg-white/[0.03] backdrop-blur-md border border-white/10 p-10 md:p-14 rounded-[3rem] shadow-2xl">
                                <form onSubmit={handleSubmit} className="space-y-8">
                                    <div className="space-y-2">
                                        <label className="text-sm font-black text-premium-gold uppercase tracking-widest ml-1">Name</label>
                                        <input
                                            type="text"
                                            required
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-premium-gold transition-colors"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-black text-premium-gold uppercase tracking-widest ml-1">Email</label>
                                        <input
                                            type="email"
                                            required
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-premium-gold transition-colors"
                                            placeholder="your@email.com"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-black text-premium-gold uppercase tracking-widest ml-1">Message</label>
                                        <textarea
                                            required
                                            rows="4"
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-premium-gold transition-colors resize-none"
                                            placeholder="How can we help?"
                                            value={formData.message}
                                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="w-full bg-premium-gold hover:bg-premium-gold-light text-premium-teal font-black py-5 rounded-2xl shadow-xl shadow-premium-gold/20 flex items-center justify-center gap-3 transition-all transform hover:scale-[1.02] active:scale-95"
                                    >
                                        Send Message
                                        <Send className="w-5 h-5" />
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
